import UserSettings from './UserSettings';

export default {
  name: 'user-settings',
  title: 'Reflex personliga inställningar',
  navbar: {
    component: UserSettings
  }
};
